import { render, staticRenderFns } from "./ESenhaFracaAlert.vue?vue&type=template&id=4e587a08"
import script from "./ESenhaFracaAlert.vue?vue&type=script&lang=js"
export * from "./ESenhaFracaAlert.vue?vue&type=script&lang=js"
import style0 from "./ESenhaFracaAlert.vue?vue&type=style&index=0&id=4e587a08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports